import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import './styles.scss'

const Hide = ({ children, breakpoint, direction }) => (
  <div className={cx({ hide: true, [`hide--${direction}-${breakpoint}`]: breakpoint })}>{children}</div>
)

Hide.propTypes = {
  children: PropTypes.node,
  breakpoint: PropTypes.oneOf(['sm', 'md', 'lg', 'hg', 'gt']),
  direction: PropTypes.oneOf(['min', 'max'])
}

export default Hide
